<template>
  <form>
    <div class="row mb-2">
      <div class="col-sm-12">

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.name") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`name`)">
              <input :class="parentProps.class" v-model="form.name" type="text" class="form-control " id="name">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="user.isTrafficGroupOnReqsEnabled">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.traffic_groups") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`trafficGroupIds`)">
              <TrafficGroupMultiselect  :class="parentProps.class" :multiple="true"  v-model="form.trafficGroups">
              </TrafficGroupMultiselect>
            </FormInputWrapper>
          </div>
        </div>
      </div>
    </div>

  </form>
</template>

<script lang="ts">
import {defineComponent, toRefs, reactive, onMounted, computed} from "vue";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import {api} from "@/service/APIClient";
import {useNotification} from "@kyvg/vue3-notification";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import Multiselect from "vue-multiselect";
import RequisiteGroupFormDTO from "@/models/form/RequisiteGroupFormDTO";
import RequisiteGroupUpdateRequestDTO from "@/models/request/RequisiteGroupUpdateRequestDTO";
import TrafficGroupMultiselect from "@/components/TrafficGroupMultiselect.vue";

const notification = useNotification()
export default defineComponent({
  components: {
    TrafficGroupMultiselect,
    Multiselect,
    FormInputWrapper,
  },
  setup() {
    const store = useStore();
    const state = reactive({
      errors: {} as ValidationErrorDTO[]|any,
      form: {} as RequisiteGroupFormDTO,
    });

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const save = () => {
      setErrors([]);
      const form = getForm();

      let promise;
      if (form.id) {
        const data = {
          ...form,
          trafficGroupIds: form.trafficGroups.map(item => item.id)
        } as RequisiteGroupUpdateRequestDTO;

        promise = api.traderRequisiteGroupUpdate(form.id, data)
      } else {
        const data = {
          ...form,
          trafficGroupIds: form.trafficGroups.map(item => item.id)
        } as RequisiteGroupUpdateRequestDTO;

        promise = api.traderRequisiteGroupCreate(data)
      }

      promise
        .catch((e: any) => {
          if (e.response && e.request && e.request.status === 400 && e.response.data) {
            setErrors(e.response.data)
          } else {
            console.log(e);
          }

        })

      return promise
    }

    const hasErrors = (path: string) => {
      return state.errors[path]?.length > 0
    }

    const getForm = (): RequisiteGroupFormDTO => {
      return state.form
    }

    const setForm = (form: RequisiteGroupFormDTO) => {
      state.errors = {}
      state.form = {
        ...form,
      }
    }

    onMounted(async () => {
    })

    return {
      ...toRefs(state),
      getForm,
      setForm,
      store,
      helper,
      numberFormatter,
      setErrors,
      getErrors,
      hasErrors,
      save,
      user: computed(() => store.getters.getUser),
    }
  }
})
</script>
